import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-page flex-col items-center justify-center px-4 py-24 text-center">
      <span className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-accent-100 text-accent-600">
        <i className="ri-basketball-line text-3xl" />
      </span>
      <p className="font-heading text-5xl font-bold text-primary-700">404</p>
      <h1 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">页面不存在</h1>
      <p className="mt-2 max-w-md text-sm text-foreground-500">
        你访问的页面可能已被移除或链接有误。返回首页查看今日直播赛程，或浏览完整赛程与回放集锦。
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link to="/" className="rounded-md bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 whitespace-nowrap cursor-pointer">
          返回首页
        </Link>
        <Link to="/category/2025-2026" className="rounded-md border border-background-300 px-6 py-2.5 text-sm font-semibold text-foreground-700 hover:bg-background-100 whitespace-nowrap cursor-pointer">
          查看赛程
        </Link>
      </div>
    </div>
  );
}